import React from 'react';
import { Button } from './SecondaryButton.styles';
export function SecondaryButton({ url, text, onClick, tabIndex }) {
    return (React.createElement(Button, { href: url, onClick: onClick, tabIndex: tabIndex }, text));
}
//# sourceMappingURL=SecondaryButton.js.map